import { Component, OnInit } from '@angular/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IdentityService } from 'src/app/core/identity.service';
import { Delegation } from 'src/app/delegations/models/delegation';
import {
    clearAssignedToMeDelegations,
    getAssignedToMeDelegations
} from 'src/app/delegations/store/actions/delegations.actions';
import {
    selectLoadingAssignedToMeDelegations,
    selectAssignedToMeDelegationsSortedByName
} from 'src/app/delegations/store/selectors/delegations.selectors';
import { DelegationsState } from 'src/app/delegations/store/delegations.state';
import { DelegationCardComponent } from 'src/app/delegations/delegation-card/delegation-card.component';
import { DelegationEmptyCardComponent } from 'src/app/delegations/delegation-empty-card/delegation-empty-card.component';

@UntilDestroy()
@Component({
    selector: 'nova-delegation-quick-access-dialog',
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        AsyncPipe,
        DelegationCardComponent,
        DelegationEmptyCardComponent,
        MatIconModule,
        MatProgressBarModule,
        MatDialogModule
    ],
    templateUrl: './delegation-quick-access-dialog.component.html',
    styleUrls: ['./delegation-quick-access-dialog.component.scss']
})
export class DelegationQuickAccessDialogComponent implements OnInit {
    aspNetUserId: string;

    activeDelegations: Delegation[] = [];
    isLoading$: Observable<boolean>;

    constructor(
        private readonly _store: Store<DelegationsState>,
        private readonly _identityService: IdentityService,
        private readonly _dialogRef: MatDialogRef<DelegationQuickAccessDialogComponent>
    ) {}

    ngOnInit(): void {
        this._dialogRef.updatePosition({ top: '40px', right: '72px' });
        this.aspNetUserId = this._identityService.current.userId;

        this._store.dispatch(clearAssignedToMeDelegations());
        this._store.dispatch(getAssignedToMeDelegations({ delegateeId: this.aspNetUserId }));

        this._store
            .select(selectAssignedToMeDelegationsSortedByName)
            .pipe(untilDestroyed(this))
            .subscribe((data) => (this.activeDelegations = data.filter((x) => x.isCurrent)));

        this.isLoading$ = this._store.select(selectLoadingAssignedToMeDelegations);
    }
}
